/**
 * エラー時に入力が合った場合に「is_error」クラスを削除
 * */
const FormDeleteInvalid = () => {
    const target = document.querySelectorAll('input.is_error, textarea.is_error, .bl_form_radioWrap.is_error input, select.is_error');
    if (!target) return;

    target.forEach(el => {
        el.addEventListener('input', (e) => {
            if (el.value) {
                const errorInput = el.closest('.bl_form_body')?.querySelector('.is_error');
                if (errorInput) {
                    errorInput.classList.remove('is_error');
                }
                
                // 入力フィールドに関連するエラーメッセージを非表示にする
                const errorMessage = el.closest('.bl_form_body')?.querySelector('.bl_form_errors');
                if (errorMessage) {
                    errorMessage.style.display = 'none';
                }
            }
        });
    });
}

export default FormDeleteInvalid;